import { Component, OnInit } from "@angular/core";
import { HeaderComponent } from "../../header/header.component";
import { SidebarComponent } from "../../sidebar/sidebar.component";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: "app-main-layout",
    templateUrl: "./main-layout.component.html",
    styleUrls: [],
    imports: [HeaderComponent, SidebarComponent, RouterOutlet]
})
export class MainLayoutComponent implements OnInit {
  direction: string;
  public config: any = {};
  constructor() {}

  ngOnInit(): void {}
}
